"use client"
// Auto-generated by `npx boneyard-js build` — do not edit
import { registerBones } from 'boneyard-js'

import _repositories_landing from './repositories-landing.bones.json'
import _trusted_domains_client from './trusted-domains-client.bones.json'

registerBones({
  "repositories-landing": _repositories_landing,
  "trusted-domains-client": _trusted_domains_client,
})
